module.exports = __webpack_public_path__ + "img/bcard_4.077166a3.png";